<template lang="pug">
    div(v-if="notEditText" @click="routerLink()" class="pointer-cursor" style="padding-top:1px; border:0px solid;") {{ linkText }}
    input(v-else type="text" @keyup.enter="saveScreenerName(screen_id)" @blur="saveScreenerName(screen_id)" v-model="editLinkText" ref="textElement" style="background-color:white; border:1px solid;")
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'LeftMenuLink',
    props: {
        screen_id: Number,
        linkText: String,
        router: String,
        params: Object
    },
    data() {
        return {
            doubleClickCheck: 0,
            notEditText: true,
            editLinkText: this.linkText
        };
    },
    computed: {
        user_id() {
            return JSON.parse(localStorage.user).user_id;
        }
    },
    methods: {
        ...mapActions([
            'editUserScreenFilters'
        ]),
        routerLink() {
            this.doubleClickCheck += 1;

            if(this.doubleClickCheck > 1) {
                this.notEditText = false;

                setTimeout(() => {
                    this.$refs.textElement.select();
                }, 100);

                this.doubleClickCheck = 0;
            }

            setTimeout(() => {
                if(this.doubleClickCheck === 1) {
                    if(this.params.id !== 0 && this.params.id !== -1) {
                        this.$router.push({name: this.router, params: {id: 0}}).catch(() => {});

                        setTimeout(() => {
                            this.$router.push({name: this.router, params: this.params}).catch(() => {});
                        }, 1);
                    } else {
                        this.$router.push({name: this.router, params: {id: 0}}).catch(() => {});
                    }
                }

                this.doubleClickCheck = 0;
            }, 300);
        },
        async saveScreenerName(screen_id) {
            const payload = {
                user_id: this.user_id,
                name: this.editLinkText,
                screen_id: screen_id
            };

            await this.editUserScreenFilters(payload);

            this.notEditText = true;
        }
    }
}
</script>

<style scoped>
.pointer-cursor {
    cursor: pointer;
}
</style>
